import {
  FC,
  useState,
  useEffect,
  createContext,
  useContext,
  useRef,
  Dispatch,
  SetStateAction,
} from 'react'
import { LayoutSplashScreen } from '../../../../_metronic/layout/core'
import { AuthModel } from './_models'
import * as authHelper from './AuthHelpers'
import { WithChildren } from '../../../../_metronic/helpers'
import { checkAndRefreshToken } from '../core/_requests'


type AuthContextProps = {
  auth: AuthModel | undefined
  saveAuth: (auth: AuthModel | undefined) => void
  logout: () => void
}

const initAuthContextPropsState = {
  auth: authHelper.getAuth(),
  saveAuth: () => { },
  logout: () => { },
}

const AuthContext = createContext<AuthContextProps>(initAuthContextPropsState)

const useAuth = () => {
  return useContext(AuthContext)
}

const AuthProvider: FC<WithChildren> = ({ children }) => {
  const [auth, setAuth] = useState<AuthModel | undefined>(authHelper.getAuth())
  const saveAuth = (auth: AuthModel | undefined) => {
    setAuth(auth)
    if (auth) {
      authHelper.setAuth(auth)
    } else {
      authHelper.removeAuth()
    }
  }

  const logout = () => {
    saveAuth(undefined)
  }

  return (
    <AuthContext.Provider value={{ auth, saveAuth, logout }}>
      {children}
    </AuthContext.Provider>
  )
}

const AuthInit: FC<WithChildren> = ({ children }) => {
  let { auth, logout, saveAuth } = useAuth()
  const [showSplashScreen, setShowSplashScreen] = useState(true)
  // We should request user by authToken (IN OUR EXAMPLE IT'S Token) before rendering the application

  function _CheckAndRefreshToken() {
    try {
    auth = authHelper.getAuth()
    if (auth === undefined || auth?.result === undefined || auth?.result.token === undefined) {
      console.log('logout : token === undefined')
      logout()
    } else {
      checkAndRefreshToken(auth?.result.token === undefined ? "" : auth?.result.token).then((apiResponse : any) => {
        // process the response
        if (apiResponse != undefined && apiResponse.data.httpStatusCode === 200) {
          let auth2 = auth
          auth2!.result.token = apiResponse.data.result.token;
            if (auth && auth2) {
            authHelper.setAuth(auth2)
          } else {
            console.log("saveAuth");
            saveAuth(auth2)
          }
        }
        else {
          console.log('logout: ' + 'httpStatusCode === 200')
          logout()
        }
      })
    }
    } catch {
      console.log("buraya girdim catch")
      logout()
    }
    setShowSplashScreen(false)
  }
  useEffect(() => {
    _CheckAndRefreshToken()
    setInterval(function () { _CheckAndRefreshToken() }, 30000);

    // eslint-disable-next-line
  }, [])

  return showSplashScreen ? <LayoutSplashScreen /> : <>{children}</>
}

export { AuthProvider, AuthInit, useAuth }
